exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrapperTitle{display:flex;flex-flow:column wrap;align-items:flex-start;justify-content:center;margin:50px 0}.title.white,.subtitle.white{color:#FFF}.title.black,.subtitle.black{color:#1F2534}.title{font-size:38px;font-weight:bold;margin-bottom:15px}.subtitle{font-size:20px;font-weight:300}\n", ""]);

